document.addEventListener('DOMContentLoaded', function() {
	const header = document.querySelector('#oc-pre-header');
	const openMenu = header.querySelector('.pre-header-oc__toggle-menu');

	openMenu.addEventListener('click', function(e){
		e.preventDefault();

		if(header.classList.contains('open')){
			header.classList.remove('open');
		}
		else{
			header.classList.add('open');
		}
	})

	const items = header.querySelectorAll('.menu li');
	const local = window.location.href;
	const localLength = local.length
	const pathname = window.location.pathname;
	const pathLenght = pathname.length;

	const domainLenght = localLength - (pathLenght - 1);
	const noPath = local.slice(0, domainLenght);

	items.forEach(item => {
		const link = item.querySelector('a');
		const url = link.getAttribute('href');
		const urlNoBar = url.concat("/")
		console.log(urlNoBar);
		if(url === local || url === noPath || urlNoBar === noPath){
			item.style.display = 'none';
		}
	})

})
